import { QuestionType } from 'typescript/enums/QuestionType.d';

import { type QuestionMultipleChoice } from 'api/types/ChapterContent/QuestionMultipleChoice';
import { type RawQuestionMultipleChoice } from 'api/types/ChapterContent/QuestionMultipleChoice/RawQuestionMultipleChoice';

import { convertImgixUrl } from 'helpers/convertImgixUrl';

const parseLabel = (label: string) => {
  if (!label.match(/^https?:\/\//)) {
    return label.trim();
  }

  return convertImgixUrl(label).trim();
};

export const parseMultipleChoice = (data: RawQuestionMultipleChoice) => {
  const types: Record<typeof data.layout, QuestionMultipleChoice['type']> = {
    mC: QuestionType.QuestionMultipleChoiceSingle,
    mMC: QuestionType.QuestionMultipleChoiceMultiple,
    mCI: QuestionType.QuestionMultipleChoiceImageSingle,
    mCD: QuestionType.QuestionMultipleChoiceDropdown,
  };

  const options: QuestionMultipleChoice['options'] = [];

  data.answer.forEach((answer, i) => {
    if (answer === null) return;

    const label = parseLabel(answer).trim();

    if (label.length === 0 || label === null) return;

    options.push({
      label: parseLabel(answer),
      correct: data.answersCorrect[i],
    });
  });

  const columns = data.columns || 0;

  const parsedData: Omit<QuestionMultipleChoice, 'image'> = {
    columns: columns > 0 ? columns : 1,
    correctAnswerText: data.correctAnswerText,
    id: data.UPID,
    incorrectAnswerText: data.incorrectAnswerText,
    options,
    pageNumber: data.pageNumber,
    question: data.question,
    title: data.question,
    type: types[data.layout],
  };

  return parsedData;
};
